<swiper-container
  #swiper
  init="false"
  (swiperslidechange)="handleSlideChange($event)"
  (swiperbreakpoint)="handleBreakpointChange($event)"
>
  <ng-content></ng-content>
</swiper-container>

<button
  tabindex="-1"
  class="previous-button"
  [class.invisible]="!hasNavigation"
  [attr.aria-label]="'pagination.previousPage' | translate"
>
  <opac-icon icon="navigate_back" [ariaHidden]="true"></opac-icon>
</button>

<button
  tabindex="-1"
  class="next-button"
  [class.invisible]="!hasNavigation"
  [attr.aria-label]="'pagination.nextPage' | translate"
>
  <opac-icon icon="navigate_next" [ariaHidden]="true"></opac-icon>
</button>
